import React from 'react';
import PropTypes from 'prop-types';

const MemberJoinedProgram = React.memo(({ data }) => {
    const programs = Array.isArray(data) ? data : [];

    return (
        <section className="profile-program-history" dir="rtl">
            <div className="profile-program-history-heading">
                <div>
                    <strong>سوابق حضور</strong>
                    <span>برنامه‌هایی که این عضو در آن‌ها شرکت کرده است</span>
                </div>
                <span className="profile-program-history-count">{programs.length} برنامه</span>
            </div>

            {programs.length ? (
                <div className="profile-program-history-list">
                    {programs.map((program, index) => (
                        <article className="profile-program-card" key={program.id || `${program.programName}-${index}`}>
                            <div className="profile-program-card-heading">
                                <div className="profile-program-card-title">
                                    <span className="profile-program-index">{String(index + 1).padStart(2, '0')}</span>
                                    <strong>{program.programName || 'برنامه بدون عنوان'}</strong>
                                </div>
                                {program.programDate ? <span className="profile-program-date">{program.programDate}</span> : null}
                            </div>

                            <div className="profile-program-card-details">
                                {program.leaderName ? <div><small>سرپرست</small><span>{program.leaderName}</span></div> : null}
                                {program.workingGroupCategoryName ? <div><small>کارگروه</small><span>{program.workingGroupCategoryName}</span></div> : null}
                            </div>

                            {program.memberComment || program.leaderComment ? (
                                <div className="profile-program-comments">
                                    {program.memberComment ? <div><small>نظر عضو</small><p>{program.memberComment}</p></div> : null}
                                    {program.leaderComment ? <div><small>نظر سرپرست</small><p>{program.leaderComment}</p></div> : null}
                                </div>
                            ) : null}
                        </article>
                    ))}
                </div>
            ) : <div className="profile-program-history-empty">سابقه‌ای برای نمایش وجود ندارد.</div>}
        </section>
    );
});

MemberJoinedProgram.propTypes = {
    data: PropTypes.any,
};

MemberJoinedProgram.displayName = 'MemberJoinedProgram';

export default MemberJoinedProgram;
